import { Services } from "slotworks/services/services";
import { Control } from "slotworks/smart-ui/controls/control";
import TotalCreditsTextControl from "slotworks/smart-ui/controls/text/total-credits-text-control";
import BetOptions from "slotworks/smart-ui/options/control-options";

export default class CreditSizeTextControl extends TotalCreditsTextControl implements Control {

    public updateOptions(betOptions: BetOptions) {
        const creditSize = betOptions.creditSizes.currentValue;

        this.text.setText(Services.currency.format(creditSize));
    }
}
